// Commit message from Theo: completed section 6 with proper formatting, also changed degree part to a dropdown menu and no longer and radio button
export default {
  name: "Job Opportunity and Minimum Requirements",
  prefix: "E.b",
  sections: [
    {
      fields: [
        {
          code: "E.b.1",
          machine_name: "eb1_job_title",
          widget: "text",
          label: "Job Title",
          maxLength: 60,
          tooltip:
            "Enter the title of the job opportunity for which temporary employment certification is being sought by the employer.",
          validate: ["required"],
        },
        {
          code: "E.b.2",
          machine_name: "eb2_num_workers",
          widget: "text",
          parse: "positiveWholeNumber",
          label: "Workers Needed",
          clearSchema: ["appx_b.appx_b_total_workers"],
          tooltip:
            "Enter the number of workers requested in the application for temporary employment certification.",
          maxLength: 4,
          validate: [
            "required",
            "number",
            {
              fieldComparison: "eb2_num_workers",
              message: "This number should be greater than or equal to 1.",
              needsFieldValues: true,
              extraData: {
                operator: ">=",
                valueOf: 1,
              },
            },
          ],
        },
        {
          code: "E.b.3",
          machine_name: "eb3_start_date",
          widget: "date",
          label: "Begin Date",
          maxDate: "eb4_end_date",
          validate: [
            "required",
            {
              dateStartCheck: "",
              message: `Please enter a begin date greater than today's date.`,
              needsFieldValues: true,
              extraData: {
                lessThanValue: 1,
              },
            },
            {
              dateStartEnd: "eb4_end_date",
              message: "Begin Date must occur before End Date.",
              needsFieldValues: true,
              extraData: {
                type: "start",
              },
            }
          ],
          tooltip:
            "Enter the begin date for the period of employment for the worker(s) requested. Use a month/day/year (mm/dd/yyyy) format.",
        },
        {
          code: "E.b.4",
          machine_name: "eb4_end_date",
          widget: "date",
          label: "End Date",
          minDate: "eb3_start_date",
          validate: [
            "required",
             {
              dateStartEnd: "eb3_start_date",
              message: "End Date must occur after Begin Date.",
              needsFieldValues: true,
              extraData: {
                type: "end",
              },
            },
            
          ],
          tooltip:
            "Enter the end date for the period of employment for the worker(s) requested. Use a month/day/year (mm/dd/yyyy) format.",
        },
      ],
    },
    {
      name: "Job Duties",
      fields: [
        {
          code: "E.b.5",
          machine_name: "eb5_job_duties",
          widget: "text_area",
          validate: ["required"],
          message: "This field cannot be more than 4000 characters long.",
          label:
            "Job Duties - Description of the specific services or labor to be performed",
          tooltip:
            "Describe the job duties, in detail, to be performed by any worker filling the job opportunity. Specify any equipment to be used and pertinent working conditions.",
          rows: 8,
          // placeholder: "",
          inputLimit: 4000,
        },
      ],
    },
    {
      name: "Anticipated days and hours of work per week",
      fields: [
        {
          isGroup: {
            // code: "E.b.6a - 6h",
            machine_name: "pwd_anticipated_days",
            label:
              "E.b.6a-6h.<br><i>(an entry is required for each box below)</i> *",
            tooltip:
              "Use items 6a through 6h to identify the anticipated days and hours of work per day and per week. Use a numerical (99.99) format for each item below. <u>An entry is required for each box listed in this field.</u>",
            coloring: "grey",
            fields: [
              {
                widget: "anticipated_date",
                label: "Sunday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "eb6b_hours_sunday",
                choice: "Sunday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Monday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "eb6c_hours_monday",
                choice: "Monday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Tuesday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "eb6d_hours_tuesday",
                choice: "Tuesday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Wednesday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "eb6e_hours_wednesday",
                choice: "Wednesday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Thursday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "eb6f_hours_thursday",
                choice: "Thursday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Friday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "eb6g_hours_friday",
                choice: "Friday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Saturday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "eb6h_hours_saturday",
                choice: "Saturday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Total", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "eb6a_hours_total",
                name: "total",
                choice: "Total:",
                validate: [
                  "required",
                  {
                    minValue: 35,
                    message:
                      "Please verify the accuracy of the entries in this section. The job opportunity must offer full-time employment that is at least 35.00 hours per week.",
                  },
                ],
                parse: "positiveNumber",
              },
            ],
          },
        },
      ],
    },
    {
      name: "Hourly work schedule",
      fields: [
        {
          isGroup: {
            // code: "E.b.7a - 7b",
            label: "<i>(an entry is required for each box below)</i> *",
            tooltip: `Use Items 7a and 7b to identify the normal daily work schedule for the job opportunity using the standard time in the area where the work is expected to be performed (e.g., 9 a.m. to 5 p.m., 7 a.m. to 11 a.m., or 4 p.m. to 8 p. m.). <br>a. Enter the start time of the day that work will normally begin and select a checkbox to indicate whether the expected start time of work is “AM” or “PM”. <br>b. Enter the end time of the day that work will normally end and select a checkbox to indicate whether the expected end time of work is “AM” or “PM”.`,
            coloring: "grey",
            fields: [
              {
                code: "E.b.7a",
                widget: "time",
                label: "Begin Time",
                machine_name: "eb7a_start_time",
                validate: ["required"],
              },
              {
                code: "E.b.7b",
                widget: "time",
                label: "End Time",
                machine_name: "eb7b_end_time",
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Education & Training",
      fields: [
        {
          isGroup: {
            code: "E.b.8",
            label: "Education: minimum U.S. diploma/degree required?",
            machine_name: "eb8_education_id",
            tooltip:
              "Identify whether the minimum U.S. diploma or degree required by the employer for the job opportunity is None, High school/GED, Associates, Bachelor’s, Master’s, Doctorate, or Other. Only mark one box.",
            coloring: "none",
            required: true,
            type: "radio",
            fields: [
              {
                widget: "radio",
                choice: "None",
                value: "NONE",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "High School/GED",
                value: "HIGHSCHOOLGED",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Associate's",
                value: "ASSOCIATES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Bachelor's",
                value: "BACHELORS",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Master's",
                value: "MASTERS",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Doctorate (Ph.D.)",
                value: "DOCTORATEPHD",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Other degree (J.D., M.D., etc.)",
                value: "OTHERDEGREE",
                validate: ["required"],
              },
            ],
          },
        },
        {
          code: "E.b.9",
          machine_name: "eb9_training_months",
          widget: "text",
          label: "Training: number of <u>months</u> required",
          validate: [
            "required",
            {
              fieldComparison: "fa8_training_months",
              message: "This number should be greater than or equal to 0.",
              needsFieldValues: true,
              extraData: {
                operator: ">=",
                valueOf: 0,
              },
            },
          ],
          maxLength: 4,
          parse: "positiveWholeNumberToInt",
          tooltip:
            "Enter the number of months of training required by the employer for the job opportunity. When answering this question, do not duplicate time requirements - the training time required should not be counted as (added to) education or experience time required",
        },
        {
          code: "E.b.10",
          machine_name: "eb10_experience_months",
          widget: "text",
          label: "Work Experience: number of <u>months</u> required",
          validate: [
            "required",
            {
              fieldComparison: "fa9_experience_months",
              message: "This number should be greater than or equal to 0.",
              needsFieldValues: true,
              extraData: {
                operator: ">=",
                valueOf: 0,
              },
            },
          ],
          maxLength: 4,
          parse: "positiveWholeNumberToInt",
          tooltip:
            'Enter the number of months of experience required by the employer. If the answer to question E.b.9 is "None", enter "0" (zero).',
        },
        {
          isGroup: {
            code: "E.b.11",
            label:
              "Supervision: does this position supervise the work of other employees?",
            machine_name: "eb11_is_supervision",
            tooltip: `Mark “Yes” or “No” as to whether the job opportunity supervises the work of other employees.`,
            coloring: "none",
            required: true,
            disabled: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                clearSchema: ["eb11a_number_supervised"],
              },
            ],
          },
        },
        {
          code: "E.b.11a",
          machine_name: "eb11a_number_supervised",
          widget: "text",
          label:
            "If 'Yes' to question 11, enter the number of employees the worker will supervise.",
          maxLength: 4,
          tooltip: `If "Yes" is marked in question 11, enter the total number of employees worker will supervise.`,
          validate: [
            "required",
            {
              fieldComparison: "eb11a_number_supervised",
              message: "This is not a valid number",
              needsFieldValues: true,
              extraData: {
                operator: ">=",
                valueOf: 1,
              },
            },
          ],
          parse: "positiveWholeNumberToInt",
          isVisible: {
            when: "eb11_is_supervision",
            is: "YES",
          },
        },
        {
          code: "E.b.12",
          machine_name: "eb12_special_requirements",
          widget: "text_area",
          label:
            "Special Requirements - List specific skills, licenses/certifications, field(s) of training, and requirements of the job.",
          validate: [
            "required",
            {
              minLength: 2,
              message: "You must describe the job-related special requirements",
            },
          ],
          message: "This field cannot be more than 4000 characters long.",
          tooltip:
            'Enter the job related special requirements. Examples are shorthand and typing speeds, specific foreign language proficiency, and test results. Document business necessity for a foreigh language requirement.  If there are no job related requirements or skills, enter "None." ',
          rows: 8,
          placeholder: "",
          inputLimit: 4000,
        },
      ],
    },
  ],
};
